import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/authentication/auth.service';
import { CacheService } from 'src/app/shared/services/cashe-service';
import { BaseComponent } from '../../component-base';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';

@Component({
  selector: 'app-iam-callback',
  templateUrl: './iam-callback.component.html',
  styleUrls: ['./iam-callback.component.css']
})
export class IamCallbackComponent extends BaseComponent implements OnInit {
  constructor(public route: ActivatedRoute,
    public _authService: AuthService,
    public override currentUserService: CurrentUserService,
    public router: Router) { super() }

  ngOnInit(): void {
    // Accessing the query parameters
    this.route.queryParamMap.subscribe(async params => {

      const token = params.get('token');
      const username = params.get('username');
      if (token && username) {
        CacheService.setToken(token);
        CacheService.setUsername(username);
        this._authService.isUserLogin$.next(true);
        await this.isCheckCompanyUser();
        // If you want to navigate after setting values
        this.router.navigateByUrl("/auth/login-type");

      } else {
        this.router.navigateByUrl("/not-active");
      }
    });
  }

  isCheckCompanyUser() {
    const userId = CacheService.getUserId();
    this.currentUserService.IsCheckCompanyUser(userId).subscribe(result => {
      CacheService.setShowHeader(String(result));
    });
  }
}
